import useMutation from "src/hooks/useMutation";

function useCustomerDelete(id) {
  return useMutation({
    path: `/api/v1/customers/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomerDelete;
